module.exports = __webpack_public_path__ + "img/8th_college.e7fd3324.webp";